import * as S from './styles'
import { formatDate } from '../../../utils/formatDate'
import { firstLetterUpperCaseAndRestLowerCase } from '../../../utils/capitalFirstLetter'
import { Button, Checkbox, Flex, Text, Tooltip, Tr } from '@chakra-ui/react'
import { useMergePdf } from '../../../hooks/useMergePdf'
import { format } from 'date-fns'

export function Row({ item, handleCheckoutItem }) {
  function situation(situacao) {
    const situationItem = ['Pendente', 'Finalizado']

    return situationItem[situacao - 3]
  }

  const { loading, mergePdf } = useMergePdf()

  async function mergePDFHandler() {
    const pdfs = [
      `${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-nota-layout/${item.numero_nota}/${item.sequencia}/${item.codigo_produto}`,
      item.link_layout,
    ]

    await mergePdf(pdfs)
  }

  return (
    <Tr
      _hover={{
        bg: item.duplicate ? 'red.100' : 'gray.100',
      }}
      bgColor={item.duplicate ? 'red.200' : 'gray.200'}
    >
      <S.Td>
        <Text as="a" href={item.link_layout} target="_blank" rel="noreferrer" color={'blue.500'} textDecoration="underline">
          {item.numero_pedido}
        </Text>
      </S.Td>
      <S.Td>
        <Tooltip label={item.nome_empresa || 'N/A'}>
          <Text isTruncated maxWidth="100px">
            {item.nome_empresa || 'N/A'}
          </Text>
        </Tooltip>
      </S.Td>
      <S.Td>
        {item.data_compra ? (
          <Flex flexDir="column" justifyContent="center" alignItems="center">
            <Text
              as="a"
              href={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-pedido-compra/${item.numero_nota}`}
              target="_blank"
              rel="noreferrer"
              color={'blue.500'}
              textDecoration="underline"
            >
              {item?.numero_nota}
            </Text>
            <Text>{format(new Date(item.data_compra), 'dd/MM/yyyy')}</Text>
            <Text>{format(new Date(item.data_compra), 'HH:mm')}</Text>
          </Flex>
        ) : (
          'Sem data'
        )}
      </S.Td>
      <S.Td>{firstLetterUpperCaseAndRestLowerCase(item.nome_vendedor)}</S.Td>
      <S.Td>
        <Tooltip label={item.descricao_produto}>
          {firstLetterUpperCaseAndRestLowerCase(item.descricao_produto)?.length > 9
            ? firstLetterUpperCaseAndRestLowerCase(item.descricao_produto).substring(0, 9).concat('...')
            : firstLetterUpperCaseAndRestLowerCase(item.descricao_produto)}
        </Tooltip>
      </S.Td>
      <S.Td>{item.codigo_produto}</S.Td>
      <S.Td>{firstLetterUpperCaseAndRestLowerCase(item.cor_produto)}</S.Td>
      <S.Td>{item.qtd}</S.Td>
      <S.Td>{item.gravacao}</S.Td>
      <S.Td>
        <Tooltip label={item.observacao}>
          <Text color={item.observacao !== '' ? 'blue.500' : 'red.500'}>
            {item.observacao !== '' ? item.observacao.substring(0, 15).concat('...') : 'Não há observação'}
          </Text>
        </Tooltip>
      </S.Td>
      <S.Td>{item.prazo_entrega}</S.Td>
      <S.Td>{item.data_saida ? formatDate(item.data_saida, true) : 'Sem data'}</S.Td>
      <S.Td>
        <Text
          as={'a'}
          href={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-nota-layout/${item.numero_nota}/${item.sequencia}/${item.codigo_produto}`} //api.innovationbrindes.com.br/api/site/v2/orcamento/visualiza-nota-layout/{NUNOTA}/{SEQUENCIA}/{CODPROD}
          color={'blue.500'}
          target="_blank"
          _hover={{
            filter: 'brightness(0.8)',
            textDecoration: 'underline',
          }}
        >
          Etiqueta
        </Text>
      </S.Td>

      <S.Td>
        <Text
          as={'a'}
          href={item.link_layout}
          color={'blue.500'}
          target="_blank"
          _hover={{
            filter: 'brightness(0.8)',
            textDecoration: 'underline',
          }}
        >
          Layout
        </Text>
      </S.Td>
      <S.Td>
        <Text
          as={'a'}
          href={item.link_dados ? item.link_dados : ''}
          color={item.link_dados ? 'blue.500' : 'red.500'}
          target="_blank"
          _hover={{
            filter: 'brightness(0.8)',
            textDecoration: 'underline',
          }}
        >
          {item.link_dados ? 'Link planilha' : 'Sem dados'}
        </Text>
      </S.Td>

      <S.Td>
        {item.terceirizado ? (
          <Button
            as="a"
            href={item.pdf_terceiro}
            target="_blank"
            rel="noreferrer"
            size="sm"
            colorScheme="blue"
            _hover={{
              filter: 'brightness(0.8)',
            }}
          >
            Ver Layout
          </Button>
        ) : (
          <Button size="sm" colorScheme="red" isDisabled={true}>
            Sem Layout
          </Button>
        )}
      </S.Td>

      <S.Td>
        <Button colorScheme="blue" size="sm" onClick={mergePDFHandler} isLoading={loading} loadingText="Abrindo...">
          Abrir
        </Button>
      </S.Td>

      <S.Td>{situation(item.situacao)}</S.Td>
      <S.Td>
        <Checkbox
          colorScheme="blue"
          isChecked={item.checked}
          borderColor="blue.500"
          _hover={{
            filter: 'brightness(0.8)',
            textDecoration: 'underline',
          }}
          onChange={() => handleCheckoutItem(item)}
        />
      </S.Td>
    </Tr>
  )
}
